import AnchorButton from 'components/AnchorButton';
import AppealDescriptionPayroll from 'content/category-content/payroll-services/appeal-description.md';
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  AnchorButton,
  AppealDescriptionPayroll,
  React,
  MDXTag
};